export default "__VITE_ASSET__BjmSBFU3__"